export { withFeatureAccess } from './with-feature-access';
